/**
 * The two kinds of order group. Each has its own pages, address and API; a
 * group of one kind is never shown on the pages of the other.
 */
export interface OrderGroupKind {
  /** Backend OrderType of the items a group of this kind holds. */
  orderType: 0 | 1;
  /** API controller of the groups of this kind. */
  api: string;
  /** Address of the list page; a group lives at `${path}/${id}`. */
  path: string;
  /** Translation keys under "orderGroups.kinds". */
  labels: "buyForMe" | "shipForMe";
  /** Whether the customer pays for the goods as part of the group total. */
  chargesGoods: boolean;
}

export const BUY_FOR_ME_GROUPS: OrderGroupKind = {
  orderType: 0,
  api: "/adminbuyformegroup",
  path: "/buyforme-groups",
  labels: "buyForMe",
  chargesGoods: true
};

export const SHIP_FOR_ME_GROUPS: OrderGroupKind = {
  orderType: 1,
  api: "/adminshipformegroup",
  path: "/shipforme-groups",
  labels: "shipForMe",
  chargesGoods: false
};
